import React from 'react';
import { SaveBar } from '@salecycle/ui-component-library';
import { useHistory, useParams } from 'react-router-dom';
import { updateRole } from '../data/EditRoleApi';
import { useEditRole } from '../context/EditRoleProvider';
import useNotifications from 'core/notifications/useNotifications';
import { useRolesContext } from '../../../context/RolesProvider';
import { useTranslation } from 'react-i18next';

export const EditRoleSaveBar: React.FC = () => {
  const { t } = useTranslation();
  const { roleId } = useParams<{ roleId: string }>();
  const { showNotification } = useNotifications();
  const { updateLocalRole } = useRolesContext();
  const {
    roleName,
    roleDescription,
    rolePermissions,
    roleUsers,
    roleNameValid,
    roleDescriptionValid,
    rolePermissionsValid,
    resetRoleChanges,
  } = useEditRole();
  const { push } = useHistory();
  const onExit = () => push('/user-management/roles');
  const onDiscard = () => resetRoleChanges();
  const returnToRolesTable = () => push('/user-management/roles');
  const [saveButtonEnabled, setSaveButtonEnabled] = React.useState(false);

  React.useEffect(() => {
    setSaveButtonEnabled(roleNameValid && roleDescriptionValid && rolePermissionsValid);
  }, [roleNameValid, roleDescriptionValid, rolePermissionsValid]);

  const onSave = () => {
    async function saveRole() {
      try {
        const response = await updateRole(roleId, {
          name: roleName,
          description: roleDescription,
          permissions: rolePermissions,
        });

        updateLocalRole(roleId, {
          ...response,
          users: roleUsers,
        });

        showNotification(t('userManagement.roles.edit.notifications.success'));
      } catch {
        showNotification(t('userManagement.roles.edit.notifications.error'), 'error');
      } finally {
        returnToRolesTable();
      }
    }

    saveRole();
  };

  return (
    <>
      <SaveBar
        onDiscardButtonClicked={onDiscard}
        onExitButtonClicked={onExit}
        onSaveButtonClicked={onSave}
        enableSaveButton={saveButtonEnabled}
      />
    </>
  );
};
